import React from "react";
import { Loader2 } from "lucide-react";
import clsx from "clsx";

function StickySaveBar({
  mode,
  canSave = true,
  errors = {},
  saving,
  onSave,
  onPreview,
  mobile = false,
}) {
  const hasErrors = Object.keys(errors).length > 0;

  // 🔒 Don't render anything if there are validation errors
  if (hasErrors) return null;

  return (
    <div
      className={clsx(
        "z-20",
        mobile
          ? "fixed inset-x-0 bottom-0 bg-white border-t p-3 shadow-lg lg:hidden"
          : "space-y-6 sticky top-28"
      )}
    >
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onSave}
          disabled={saving || !mode || !canSave}
          className="flex-1 rounded-lg bg-blue-600 px-4 py-2 text-white font-medium disabled:opacity-50"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save"}
        </button>
        <button
          type="button"
          onClick={onPreview}
          disabled={saving || !mode}
          className="flex-1 rounded-lg bg-gray-100 px-4 py-2 font-medium hover:bg-gray-200 disabled:opacity-50"
        >
          Preview
        </button>
      </div>
    </div>
  );
}

export default StickySaveBar;
export { StickySaveBar };
